import { MANAGER, FINANCE, DIRECTOR } from "../../../../../utils/Roles";

export const AGECAR = {
  value: "AGECAR",
  key: "importExport.formats.agecar",
  manualBillingOnly: true,
};
export const AGECTR = {
  value: "AGECTR",
  key: "importExport.formats.agectr",
  manualBillingOnly: true,
};
export const MONDIAL = {
  value: "MONDIAL",
  key: "importExport.formats.mondial",
};
export const WITHDRAWAL = {
  value: "WITHDRAWAL",
  key: "importExport.formats.withdrawal",
  manualBillingOnly: true,
  allowedRoles: [MANAGER, FINANCE, DIRECTOR],
};
export const SYMBILITY = {
  value: "SYMBILITY",
  key: "importExport.formats.symbility",
};
export const FEUS = {
  value: "FEUS",
  key: "importExport.formats.feus",
  manualBillingOnly: true,
  isSpecificForClient: true
};

export default [AGECAR, AGECTR, MONDIAL, WITHDRAWAL, SYMBILITY, FEUS];



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exportMembers/enums/exportMemberFormats.js